export const getApiBaseUrl = () => {
    // return 'http://127.0.0.1:8000/api';
    return 'https://api.amaanarabia.com/api';
};

export const getStorageUrl = (path: string): string => {
    // const BASE_URL = 'http://127.0.0.1:8000/storage/';
    const BASE_URL = 'https://api.amaanarabia.com/storage/';
    return path ? `${BASE_URL}${path}` : '';
};
